export interface IUserData {
  id: number;
  uuid: string;
  isBlocked: boolean;
  oldMongoId: string;
  site_id: string;
  createdAt: Date;
  updatedAt: Date;
  userType: EnumUserType;
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  status: string;
  phone: string;
  phoneCode: string;
  oldPhone: string;
  companyId: null;
  isDetailPending: boolean;
  originalStaffUserId: null;
  otp: string;
  otpExpiry: Date;
  legalEntityId: number;
  dmcMarketId: number;
  taLogoUrl: null;
  customer: null;
  company: null;
  fullName: string;
  phoneNumbers: any[];
}

export enum EnumUserType {
  RETAIL = "retail",
  TRAVELAGENT = "travelAgent",
  CORPORATE = "corporate",
  STAFF = "staff",
}
